// Converts between the plain conditions shape used for storage/runtime
// evaluation (see shared/composables/useRuntimeConfiguratorGeneration.js and
// shared/utils/conditionsEvaluator.js) and the input-binding shape
// ({ binding, error, rules }) that ConditionModal/ConditionGroup use for
// their own form state.

export const wrapConditions = (conditions = {}) => ({
  type: { binding: conditions.type || 'show', error: '', rules: ['required'] },
  betweenGroupLogic: {
    binding: conditions.betweenGroupLogic || 'AND',
    error: '',
    rules: ['required'],
  },
  groups: {
    binding: (conditions.groups || []).map((group) => ({
      logic: { binding: group.logic || 'AND', error: '', rules: ['required'] },
      rules: (group.rules || []).map((rule) => ({
        elementId: { binding: rule.elementId || '', error: '', rules: ['required'] },
        operation: { binding: rule.operation || 'equals', error: '', rules: ['required'] },
        value: { binding: rule.value ?? '', error: '', rules: ['required'] },
      })),
    })),
  },
});

export const unwrapConditions = (form) => ({
  type: form.type.binding,
  betweenGroupLogic: form.betweenGroupLogic.binding,
  groups: form.groups.binding.map((group) => ({
    logic: group.logic.binding,
    rules: group.rules.map((rule) => ({
      elementId: rule.elementId.binding,
      operation: rule.operation.binding,
      value: rule.value.binding,
    })),
  })),
});
